import { createStore } from '@/lib/store'

/**
 * Inputs the page hands to the 3D scene every frame. Plain mutable values, written by DOM
 * listeners and read inside the render loop, so scrolling never re-renders React.
 */
export const sceneInput = {
    /** Scroll position mapped to story chapters: 0 = hero, 1 = power ... 5 = configurator. */
    chapter: 0,
    /** Mouse position across the window, -1 to 1. */
    pointerX: 0,
    pointerY: 0,
    /** Extra truck rotation from dragging, in radians. */
    yaw: 0,
    yawVelocity: 0,
    dragging: false,
    /** performance.now() of the last drag. */
    lastInteraction: 0,
    reducedMotion: false
}

export const uiStore = createStore({
    activeChapter: 0,
    sceneReady: false,
    sceneFailed: false
})
